
import { Vue, Component, Prop } from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import DataTableWrapper from '@/features/common/components/DataTableWrapper.vue';
import HistoryItem from '@/features/pickup-history/components/HistoryItem.vue';
import NoResultsFound from '@/features/common/components/NoResultsFound.vue';
import { ScheduledPickupItem } from '@/features/schedule-pickup/types';
import { fetchMoreUsingScrollWindow } from '@/features/common/helpers';

export interface FilteredPickupHistories {
  today: ScheduledPickupItem[],
  upcoming: ScheduledPickupItem[],
  history: ScheduledPickupItem[],
}

@Component({
  components: {
    DataTableWrapper,
    HistoryItem,
    NoResultsFound,
  },
})
export default class HistoryTable extends Vue {
  @Prop({ required: false, default: false }) loading!: boolean;

  @Prop({ required: true }) histories!: FilteredPickupHistories;

  @Prop({ required: false, default: false }) isFutureDayPickups!: boolean;

  @Prop({ required: true }) dateSortingActive!: boolean;

  @Prop({ required: true }) order!: boolean;

  @Prop({ required: false, default: true }) isLoadMoreHint!: boolean;

  get totalPickupsCount(): number {
    const { upcoming, today, history } = this.histories;
    let count = history.length + today.length;

    if (this.isFutureDayPickups) {
      count += upcoming.length;
    }

    return count;
  }

  mounted(): void {
    const onScroll = () => {
      this.debounceFetchPickupHistories();
    };

    window.addEventListener('scroll', onScroll);
  }

  private debounceFetchPickupHistories = debounce(this.fetchMorePickupHistoriesHandler, 200);

  private async fetchMorePickupHistoriesHandler(): Promise<void> {
    const callback = () => {
      this.$emit('fetchMoreItems');
    };
    fetchMoreUsingScrollWindow(callback);
  }
}
